module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/alex-edelmann-23674d8674e50964e82ad3787719a745.jpg";